export const config = (kjsList, municipalityList) => {
  return {
    fields: [
      {
        key: 1,
        name: 'kjs.uniqueNumber',
        type: 'text',
        component: 'input',
      },
      {
        key: 2,
        name: 'kjs.pib',
        type: 'text',
        component: 'input',
      },
      {
        key: 3,
        name: 'kjsEntity',
        type: 'autocomplete',
        optionList: kjsList || [],
        getOptionLabel: (KjsTable) => KjsTable.name || '',
      },
      {
        key: 3,
        name: 'municipality',
        type: 'autocomplete',
        optionList: municipalityList || [],
        getOptionLabel: (municipality) => municipality.name || '',
      },
    ],
  };
};
